<template>
  <div
    id="com_mod_valuation"
    class="com-mod-section-container"
  >
    <div class="gray-bar-top app clearfix">
      <div class="row">
        <div class="col-md-12">
          <h3 class="app-title">
            Valuation
          </h3>
        </div>
        <div class="col-md-12">
          <table>
            <thead>
              <tr>
                <th scope="col" />
                <template v-for="i in 3" :key="`${i}`">
                  <th
                    scope="col"
                    class="table-data align-right"
                  >
                    Price/
                  </th>
                </template>
              </tr>
              <tr class="gray-bar-bottom">
                <th scope="col" />
                <th
                  class="table-data align-right"
                  scope="col"
                >
                  Book
                  <i-ball-modal tag="PBRAT" />
                </th>
                <th
                  class="table-data align-right"
                  scope="col"
                >
                  Cash Flow
                  <i-ball-modal tag="PCRAT" />
                </th>
                <th
                  class="table-data align-right"
                  scope="col"
                >
                  Earnings
                  <i-ball-modal tag="PERAT" />
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="gray-bar-bottom">
                <td class="com-mod-table-data align-left">
                  Fund
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ $format.formatExtraZero(getValuation.mstarPriceToBook) }}
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ $format.formatExtraZero(getValuation.mstarPriceToCash) }}
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ $format.formatExtraZero(getValuation.mstarPriceToEarnings) }}
                </td>
              </tr>
              <tr class="gray-bar-bottom">
                <td
                  class="com-mod-table-data align-left"
                  style="width: 130px;"
                >
                  {{ indexName }}
                  <disclosure-superscript
                    class="detail-page"
                    :statistics="[indexId]"
                    anchor="valuationPrimaryIndex"
                  />
                  <i-ball-modal :tag="indexId" />
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ tryValuationIndex('indexPriceToBook') }}
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ tryValuationIndex('indexPriceToCash') }}
                </td>
                <td class="com-mod-table-data align-right strong">
                  {{ tryValuationIndex('indexPriceToEarnings') }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="col-md-12">
          <span class="sub-info adjust-date">
            Fund as of {{ $format.shortDate(getValuation.mstarPortfolioDate) }}. Index as of {{ $format.shortDate(getValuation.indexPortfolioDate) }}.
          </span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	name: 'ValuationModule',
	computed: {
		...mapGetters([
			'getFundInfoData',
			'getValuation'
		]),
		//CG-17793: use the cgIndexID from /fund-info as the Valuation Benchmark index unless there is an cgIndexID from /returns-module
		indexId() {
			let result = '';
			if (this.getFundInfoData && this.getFundInfoData.cgIndexID) result = this.getFundInfoData.cgIndexID;
			if (this.getValuation && this.getValuation.cgIndexID) result = this.getValuation.cgIndexID;
			return result;
		},
		//CG-17793: use the cgIndexID from /fund-info as the Valuation Benchmark index unless there is an cgIndexID from /returns-module
		indexName() {
			let result = '';
			if (this.getFundInfoData && this.getFundInfoData.cgIndexName) result = this.getFundInfoData.cgIndexName;
			if (this.getValuation && this.getValuation.cgIndexName) result = this.getValuation.cgIndexName;
			return result;
		}
	},
	watch: {
		getValuation: {
			immediate: true,
			handler(val) {
				this.$EventBus.$emit('ExcelData', 'ValuationModule', { ...val, asOfDate: `Fund as of ${this.$format.shortDate(val.mstarPortfolioDate)}. Index as of ${this.$format.shortDate(val.indexPortfolioDate)}.` });
			}
		}
	},
	methods: {
		//CG-17793: unless Benchmark index is available from /returns-module, use null values in table
		tryValuationIndex(key) {
			let result = '--';
			if (this.getValuation && this.getValuation[key]) result = this.$format.formatExtraZero(this.getValuation[`${key}`]);
			return result;
		}
	}
};
</script>

<style lang="less" scoped>
#afis-app {
	#com_mod_valuation {
		tr td:not(:first-child) {
			color: #333333;
		}
		thead {
			tr:nth-child(2) {
				th {
					padding: 0px 5px 5px 10px;
				}
			}
		}
		td {
			padding: 5px 5px 5px 0px;
			margin: 1px 0px 1px 0px;
		}
	}
}


</style>

